(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fishenzo-navigation"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fishenzo-navigation')) {
 customElements.define('fishenzo-navigation', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort=new AbortController(); const opts={signal:this.abort.signal};
   this.root=this.querySelector('.fn-root'); this.categories=[...this.querySelectorAll('.fn-category')];
   this.desktop=window.matchMedia('(min-width:990px)');
   const reset=()=>{this.categories.forEach(c=>c.open=false);this.root.open=this.desktop.matches;}; reset();
   this.desktop.addEventListener('change',reset,opts);
   this.categories.forEach(c=>{
    c.querySelector('summary').addEventListener('pointerenter',e=>{if(this.desktop.matches&&e.pointerType==='mouse'){clearTimeout(this.timer);this.closeOthers(c);c.open=true;}},opts);
    c.querySelector('summary').addEventListener('click',()=>this.closeOthers(c),opts);
   });
   this.addEventListener('pointerenter',()=>clearTimeout(this.timer),opts);
   this.addEventListener('pointerleave',e=>{if(this.desktop.matches&&e.pointerType==='mouse')this.timer=setTimeout(()=>this.closeOthers(null),180);},opts);
   this.addEventListener('keydown',e=>{if(e.key==='Escape'){const c=e.target.closest('.fn-category');this.closeOthers(null);if(c)c.querySelector('summary').focus();else this.root.querySelector('summary').focus();if(!this.desktop.matches)this.root.open=false;e.preventDefault();}},opts);
   document.addEventListener('pointerdown',e=>{if(!this.contains(e.target)){this.closeOthers(null);if(!this.desktop.matches)this.root.open=false;}},opts);
   this.addEventListener('focusout',()=>{setTimeout(()=>{if(!this.contains(document.activeElement))this.closeOthers(null);},0);},opts);
   document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)){this.root.open=true;const c=e.target.querySelector('.fn-category');if(c){this.closeOthers(c);c.open=true;}}},opts);
   const scroll=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.classList.toggle('is-stuck',this.desktop.matches&&window.scrollY>60&&this.getBoundingClientRect().top<=1);this.frame=null;});};
   window.addEventListener('scroll',scroll,{...opts,passive:true});window.addEventListener('resize',scroll,opts);scroll();
  }
  closeOthers(active){this.categories.forEach(c=>{if(c!==active)c.open=false;});}
  disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);cancelAnimationFrame(this.frame);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
